"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Twin
 *
 * Given two sequences, interweave them, alternating terms
 */
// Public API
exports.default = function (a, b) {
  return (0, immutable_1.Seq)(generator(a, b));
};
// Generator
function generator(a, b) {
  var counter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return counter % 2 === 0 ? a.first() : b.first();

        case 2:
          return _context.delegateYield(generator(a, b, counter + 1), "t0", 3);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=twin.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/twin.js
// module id = 282
// module chunks = 0